export default __webpack_public_path__ + "static/banner-457ec4bfb97e177f4a241d0a088c9d28.png";